.authPage {
  padding: 1rem;
}
.form {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 320px;
}
.form input {
  padding: 0.5rem;
}
.form button {
  padding: 0.6rem;
}
.error {
  color: red;
}
